export default "__VITE_ASSET__WNFq9v7m__"